var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLvl2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_302_8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    fill: "#652B6E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5168 30.92H14.3968V33H7.4368V19.14H9.5168V30.92ZM19.5187 33H18.4187L14.1987 23.7H16.3387L18.9787 30.14L21.6587 23.7H23.7587L19.5187 33ZM26.6457 33H24.6657V19.14H26.6457V33ZM33.2538 22.78C33.2538 22.3267 33.3538 21.8667 33.5538 21.4C33.7538 20.92 34.0338 20.4867 34.3938 20.1C34.7672 19.7133 35.2072 19.3933 35.7138 19.14C36.2338 18.8867 36.8072 18.76 37.4338 18.76C38.0205 18.76 38.5605 18.88 39.0538 19.12C39.5605 19.3467 39.9938 19.6533 40.3538 20.04C40.7138 20.4133 40.9938 20.8467 41.1938 21.34C41.4072 21.82 41.5138 22.3067 41.5138 22.8C41.5138 23.3467 41.4472 23.8533 41.3138 24.32C41.1938 24.7733 41.0205 25.2133 40.7938 25.64C40.5672 26.0533 40.3005 26.4667 39.9938 26.88C39.6872 27.28 39.3605 27.6867 39.0138 28.1L37.8738 29.46C37.6738 29.7 37.4538 29.96 37.2138 30.24C36.9738 30.5067 36.7472 30.7533 36.5338 30.98C36.8138 30.9533 37.1205 30.94 37.4538 30.94C37.8005 30.9267 38.1272 30.92 38.4338 30.92H41.7338V33H33.1938V31.92L37.2538 26.92C37.6538 26.4267 37.9938 26 38.2738 25.64C38.5672 25.28 38.8005 24.9533 38.9738 24.66C39.1472 24.3533 39.2738 24.0667 39.3538 23.8C39.4338 23.52 39.4738 23.2133 39.4738 22.88C39.4738 22.6 39.4138 22.34 39.2938 22.1C39.1738 21.86 39.0138 21.6533 38.8138 21.48C38.6272 21.2933 38.4005 21.1467 38.1338 21.04C37.8805 20.9333 37.6138 20.88 37.3338 20.88C36.8005 20.88 36.3338 21.08 35.9338 21.48C35.5472 21.88 35.2872 22.38 35.1538 22.98L33.2538 22.78Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_302_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLvl2);
export default __webpack_public_path__ + "static/media/lvl2.670747c324b93e9654265326c9741825.svg";
export { ForwardRef as ReactComponent };